// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact__VTdpH","title":"contact_title__39tiu","disabled":"contact_disabled__1qXyg"};